import { AppState } from './reducers';

export const getTrial = (state: AppState) => {
  return state.affiliate.trial;
};

export const getRef = (state: AppState) => {
  return state.affiliate.ref;
};

export const getChoosenDomain = (state: AppState) => {
  const { activeType } = state.domain;
  if (!activeType) {
    return {};
  }
  const { value, rawValue } = state.domain.fields[activeType];
  return {
    type: activeType,
    rawValue,
    value,
  };
};

export const getPackageType = (state: AppState) => {
  return state.pricing.selectedPackage;
};

export const getIndustry = (state: AppState) => {
  return state.intent.industry;
};

export const getOther = (state: AppState) => {
  return state.intent.other;
};

export const isSkippedIndustryView = (state: AppState) => {
  return state.intent.skipIndustryView;
};

export const getSelectedSubtype = (state: AppState) => {
  return state.template.selectedSubtype;
};

export const isSkippedTemplateView = (state: AppState) => {
  return state.template.skipTemplateView;
};

export const getSelectedTrackingState = (state: AppState) => {
  const trial = getTrial(state);
  const ref = getRef(state);
  const domain = getChoosenDomain(state);
  const packageType = getPackageType(state);
  const industry = getIndustry(state);
  const other = getOther(state);
  const skippedIndustryView = isSkippedIndustryView(state);
  const subtype = getSelectedSubtype(state);
  const skippedTemplateView = isSkippedTemplateView(state);

  return {
    ref,
    trial,
    domain,
    industry,
    other,
    packageType,
    skippedIndustryView,
    subtype,
    skippedTemplateView,
  };
};
